import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-config-maintain-layout',
  templateUrl: './config-maintain-layout.component.html',
  styleUrls: ['./config-maintain-layout.component.less']
})
export class ConfigMaintainLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
